/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { PostActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        posts: state.posts
    });
}

function mapDispatchToProps(dispatch) {
    return {
        createPost: (post) => {
            dispatch(PostActions.createPost(post));
        },
        createPostV1: (post) => {
            dispatch(PostActions.createPostV1(post));
        },
        getPost: (id) => {
            dispatch(PostActions.fetchPost(id));
        },
        uploadPost: (post) => {
            dispatch(PostActions.uploadPost(post));
        },
        getPostPreview: (id, pipID) => {
            dispatch(PostActions.fetchPostPreview(id, pipID));
        },
        getPostValidators: () => {
            dispatch(PostActions.fetchPostValidators());
        },
        getPostMediaValidation: (data) => {
            dispatch(PostActions.fetchPostMediaValidation(data));
        },
        getMediaGallery: (data) => {
            dispatch(PostActions.fetchMediaGallery(data));
        }
	};
}

export default function PostProvider(Component) {

    class PostProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    PostProvider.displayName = "PostProvider";

    return connect(mapStateToProps, mapDispatchToProps)(PostProvider);
};
